
<form [formGroup]="confirmFormGroup">
    <div>
        <div>
            <span class="text-center border-round-sm font-bold">Data sottoscrizione: {{signer.subscriptionDate | date: 'yyyy-MM-dd'}}</span>
        </div>
        <div class="mt-3">
            <span class="text-center border-round-sm font-bold">Nominativo e ruolo: {{signer.delegateName}}</span>
        </div>
            
        <div class="mt-3">
            <div>
                <span class="text-center border-round-sm font-bold">Luogo</span>
            </div>
            <div>
                <input type="text" pInputText formControlName="subscriptionPlace" [(ngModel)]="signer.subscriptionPlace" />
            </div>
        </div>
            
        <div class="mt-3">
            <p-toggleButton class="mr-2 mb-2" formControlName="showSign" [(ngModel)]="signer.showSign" onLabel="Firma" offLabel="Non firmare"></p-toggleButton>
        </div>
            
        <div [hidden]="!signer.showSign" class="col-fixed" style="width:100%">
            <span class="text-center border-round-sm font-bold">Firma</span>
            <p-selectButton [options]="availableFonts" [allowEmpty]="false" (onOptionClick)="selectedFont = $event.option"></p-selectButton>
        </div>
        
        <div [hidden]="!signer.showSign" class="col-fixed" style="width:100%; min-height: 170px; height: fit-content;">
            <ng-container *ngFor="let font of availableFonts">
                <h1 class="{{selectedFont}} text-6xl text-center" *ngIf="selectedFont === font">{{signer.delegateName}}</h1>
            </ng-container>
        </div>
        <!-- <div class="mt-3" style="position: relative; border: 1px solid black;">
            <p-button class="eraser-button" [outlined]="true" icon="pi pi-eraser" (onClick)="signWhiteboard!.clearDraw()" severity="danger"></p-button>
            <ng-whiteboard class="w-full" #signWhiteboard [data]="delSign" (save)="onSignWhiteboardSave($event)" (dataChange)="dataSignChanged($event)" backgroundColor="#FFFFFF" [drawingEnabled]="true"></ng-whiteboard>
        </div> -->
    </div>
    <div class="mt-2">
        <p-button class="mr-2" label="Annulla" (onClick)="cancel()" [outlined]="true" severity="danger" icon="pi pi-times"></p-button>
        <p-button label="Conferma" [disabled]="!confirmFormGroup.valid" (onClick)="confirm()" [outlined]="true" icon="pi pi-check"></p-button>
    </div>
</form>